import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const LineChart = React.lazy(() => import('../../components/charts/LineChart'));

function Chart(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>آمار</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <LineChart {...props} />
      </Suspense>
    </Page>
  );
}

export default Chart;
